import { render, staticRenderFns } from "./ProjectGroupForm.vue?vue&type=template&id=1e5ee30c&"
import script from "./ProjectGroupForm.vue?vue&type=script&lang=js&"
export * from "./ProjectGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports